import React from 'react';

const SessionMetricsCards = ({ metrics, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  const formatDuration = (seconds) => {
    if (!seconds || seconds < 60) {
      return `${Math.round(seconds || 0)}s`;
    } else if (seconds < 3600) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.round(seconds % 60);
      return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
    } else {
      const hours = Math.floor(seconds / 3600);
      const mins = Math.round((seconds % 3600) / 60);
      return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    }
  };

  // Card component - matching User Journey style
  const StatCard = ({ title, value, isLoading = false }) => (
    <div className="p-4 md:p-6 text-center" style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}>
      <div className="text-xs font-medium mb-2" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
        {title}
      </div>
      {isLoading ? (
        <div className="h-8 mb-1 animate-pulse" style={{ backgroundColor: styles.secondaryBg }}></div>
      ) : (
        <div className="text-lg md:text-xl font-semibold mb-1" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
          {value}
        </div>
      )}
    </div>
  );

  const cards = [
    {
      title: 'Total Sessions',
      value: metrics?.totalSessions?.toLocaleString() || '0',
      loading: isLoading
    },
    {
      title: 'Pages per Visit',
      value: metrics?.pagesPerVisit ? Number(metrics.pagesPerVisit).toFixed(2) : '0.00',
      loading: isLoading
    },
    {
      title: 'Avg Visit Duration',
      value: formatDuration(metrics?.avgVisitDuration),
      loading: isLoading
    },
    {
      title: 'Bounce Rate',
      value: `${(metrics?.bounceRate || 0).toFixed(1)}%`,
      loading: isLoading
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <StatCard key={index} title={card.title} value={card.value} isLoading={card.loading} />
      ))}
    </div>
  );
};

export default SessionMetricsCards;
